import React from "react";
import { Link } from "react-router-dom";
import { isCareersPageEnabled } from "./featureFlag";

function Footer() {
  return (
    <>
      <footer class="tp-footer-area-2 pt-100 p-relative z-index-1">
        {/* <div class="bg-patten"><img src="../assets/images/patten-bg.png" alt="" /></div>  */}
        <div class="tp-footer-main-area tp-footer-border">
          <div class="container">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                <div class="tp-footer-widget tp-footer-2-col-1 mb-50">
                  <div class="tp-footer-logo mb-20">
                    <h1>Kubera Financial Services LLC</h1>
                  </div>
                  <div class="tp-footer-widget-content">
                    <p>
                      Kubera Financial Services LLC primary mission is to
                      provide financial freedom for our clients .Our vision is
                      to be a step ahead in the financial revolution.
                    </p>
                    <p>
                      We offer comprehensive financial services designed to help
                      you achieve financial security and peace of mind.
                    </p>
                    <div class="tp-footer-widget-social">
                      <a
                        target="_blank"
                        href="https://www.facebook.com/people/Kubera-Financial-Services-LLC/61558366419478/"
                      >
                        <i class="fa-brands fa-facebook-f"></i>
                      </a>
                      <a target="_blank" href="https://x.com/kfsllc">
                        <i class="fa-brands fa-twitter"></i>
                      </a>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/getrichwithkubera?igsh=azdnYWI2ZTNkZXlx"
                      >
                        <i class="fa-brands fa-instagram"></i>
                      </a>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/@KFSAgentMentor"
                      >
                        <i class="fa-brands fa-youtube"></i>
                      </a>
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/in/kubera-financial-services-llc-aa1521407/?isSelfProfile=true"
                      >
                        <i class="fa-brands fa-linkedin"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6">
                <div class="tp-footer-widget tp-footer-2-col-2 mb-50">
                  <h3 class="tp-footer-widget-title">Services</h3>
                  <div class="tp-footer-widget-content-link">
                    <div class="tp-footer-widget-content">
                      <ul>
                        <li>
                          <Link to="/EstatePlanning">Estate Planning</Link>
                        </li>
                        <li>
                          <Link to="/HealthInsurance">Health Insurance</Link>
                        </li>
                        <li>
                          <Link to="/LifeInsurance">Life Insurance</Link>
                        </li>
                        <li>
                          <Link to="/Annuities">Annuities</Link>
                        </li>
                        <li>
                          <Link to="/NotaryPerson">Notary In Person</Link>
                        </li>
                        <li>
                          <Link to="/NotaryRemote">Notary Remote Online</Link>
                        </li>
                      </ul>
                    </div>
                    <div class="tp-footer-widget-content">
                      <ul>
                        <li>
                          <Link to="/RetirementPlanning">
                            Retirement Planning
                          </Link>
                        </li>
                        <li>
                          <Link to="/TaxOptimization">Tax Optimization</Link>
                        </li>
                        <li>
                          <Link to="/ExpertRollovers">
                            Expert 401K Rollover
                          </Link>
                        </li>
                        <li>
                          <Link to="/DebtManagement">Debt Management</Link>
                        </li>
                        <li>
                          <Link to="/WealthManagement">Wealth Management</Link>
                        </li>
                        <li>
                          <Link to="/BusinessOpportunity">
                            Business Opportunity
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div class="tp-footer-widget tp-footer-2-col-4 mb-50">
                  <h3 class="tp-footer-widget-title">Quick Links</h3>
                  <div class="tp-footer-widget-content tp-footer-widget-content-1">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/AboutUs">About Us</Link>
                      </li>
                      {isCareersPageEnabled ? (
                        <li>
                          <Link to="/Careers">Careers</Link>
                        </li>
                      ) : (
                        <li>
                          <Link to="/Payment">Payment </Link>
                        </li>
                      )}
                      <li>
                        <Link to="/ContactUs">Contact Us </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tp-footer-copyright-area p-relative">
          <div class="container">
            <div class="row">
              {/* <div class="col-md-12 col-lg-6">
                        <div class="tp-footer-copyright-inner text-lg-left">
                           <a href="#">Privacy Policy</a>
                           <a href="#">Help Center</a> 
                        </div>
                     </div> */}
              <div class="col-md-12 col-lg-12">
                <div class="tp-footer-copyright-inner tp-footer-copyright-inner-1">
                  <p>© 2024 Kubera Financial Services All Rights Reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
